import { CenteredDiv, Container, Img } from '@main/core-ui';
import { ASSET_BASE_URL } from '@main/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { networkErrorMessages } from './messages';

/**
 * Not found props
 */
export interface NetworkErrorProps {
  /** The src of the not found image */
  imgSrc?: string;
}

/**
 * Render an error when the backend cannot be reached
 */
export function NetworkError({
  imgSrc = `${ASSET_BASE_URL}/network-error.svg`,
}: NetworkErrorProps): JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <Container>
      <CenteredDiv>
        <Helmet>
          <title>{formatMessage(networkErrorMessages.title)}</title>
          <meta
            content={formatMessage(networkErrorMessages.title)}
            name="description"
          />
        </Helmet>
        <h1>{formatMessage(networkErrorMessages.header)}</h1>
      </CenteredDiv>
      <CenteredDiv>
        <Img
          src={imgSrc}
          width="550px"
          style={{ margin: '70px 0', maxHeight: '404px' }}
          alt={formatMessage(networkErrorMessages.alt)}
        />
      </CenteredDiv>
      <CenteredDiv>
        <small>{formatMessage(networkErrorMessages.extension)}</small>
      </CenteredDiv>
    </Container>
  );
}

export default NetworkError;
